<template>
  <Modal
    @close="$emit('close')"
    :classes="'col-md-4'"
    title="Asignación de rating"
  >
    <div slot="body">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <i
              class="fas fa-star pointer"
              v-for="(item, i) in new Array(5)"
              :class="{
                'text-secondary': i + 1 <= marked,
                'text-gray': i + 1 > marked,
              }"
              @mouseenter="marked = i + 1"
              @mouseleave="marked = 0"
              :key="i"
              @click.stop="setRating(i + 1)"
            />
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal";

export default {
  name: "RatingModal",
  components: {
    Modal,
  },
  props: ["challengeData"],
  data() {
    return {
      data: null,
      marked: 0,
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData", "userData"]),
  },
  methods: {
    async setRating(rating) {
      let action = "updateTestRating";
      let method = "put";
      if (this.data.rating == 0) {
        action = "addTestRating";
        method = "post";
      }
      let apiUrl = `${this.dataUrl}/testRating/${action}`;
      let apiData = {
        id: null,
        desafio: {
          id: this.data.id,
        },
        lbUserId: this.teacherData.id,
        description: "",
        rating,
      };

      let loader = this.$loading.show();
      try {
        let { data } = await this.axios[method](apiUrl, apiData);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Desafío puntuado exitosamente"],
            type: "success",
          });
          this.$emit("setRating", data.content.rating);
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
  mounted() {
    this.data = this.challengeData;
  },
};
</script>
